export default __webpack_public_path__ + "static/media/Vector_loader.3121dfe4.gif";